import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createAddPersonaToCardCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddPersonaToCard extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'AddPersonaToCard';

    public constructor(public cardId: string, public personaId: string, public shouldSendCommand: boolean = true) {
        super(AddPersonaToCard.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddPersonaToCard): Promise<boolean> => {
    if (action.shouldSendCommand) {
        await useSendCommandAsync(action, {
            createCommand: async () => await createAddPersonaToCardCommand(action),
        });
    }

    return true;
};

const reducer = (state: StorymapState, action: AddPersonaToCard): void => {
    const card = getCardById(action.cardId);

    if (card != null) {
        if (!card.personaIds.includes(action.personaId)) {
            card.personaIds.push(action.personaId);
        }
    }
};

//@ts-ignore
registerMiddleware(AddPersonaToCard.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(AddPersonaToCard.ACTION_TYPE, reducer);
